// Copyright (c) Microsoft Corporation.
// Licensed under the MIT license.

import { appInfo } from "./appInfo"

const appVersionRaw = appInfo.version
const appVersionArr = appVersionRaw.split(".");
appVersionArr[1] = appVersionArr[1] + "-preview";
const appVersion = appVersionArr.join(".");

const enableAPIVersionSelection = appInfo.enableAPIVersionSelection;
const enablePredictionResultUpload = appInfo.enablePredictionResultUpload;
const apiVersion = "2023-07-31";
//const apiVersion = "2022-08-31";
//const apiVersion = "2022-01-30-preview";
//const apiVersion = "2022-06-30-preview";

/**
 * Constants used throughout application
 */
export const constants = {
    version: "pubpreview_1.0",
    appVersionRaw,
    appVersion,
    apiVersion,
    enableAPIVersionSelection,
    enablePredictionResultUpload,
    projectFormTempKey: "projectForm",
    projectFileExtensionOld: ".vott",
    projectFileExtension: ".fott",
    labelFileExtension: ".labels.json",
    ocrFileExtension: ".ocr.json",
    fieldsFileName: "fields.json",
    maxConcurrentServiceRequests: 100,
    statusCodeSucceeded: "succeeded",
    statusCodeReady: "ready",
    statusCodeFailed: "failed",
    statusCodeInvalid: "invalid",
    apiKeyHeader: "Ocp-Apim-Subscription-Key",
    maxRetry: 8,
    initialRetryInterval: 500, // ms
    convertedImageFormat: "image/jpeg",
    convertedImageQuality: 0.7,
    convertedThumbnailQuality: 0.2,
    recentModelRecordsCount: 5,
    // eslint-disable-next-line
    apiModelsPath: "/formrecognizer/documentModels:build?api-version=${apiVersion}",
    apiModelPath: "/formrecognizer/documentModels/${modelId}?api-version=${apiVersion}",
    apiModelsPathV3: "/formrecognizer/documentModels?api-version=${apiVersion}",
    apiModelsAnalyzePath: "/formrecognizer/documentModels/{modelId}:analyze?api-version=",    
    apiComposeModelsPath: "/formrecognizer/documentModels:compose?api-version=${apiVersion}",
    autoLabelBatchSizeMax: 1000,
    autoLabelBatchSizeMin: 10,
    showOriginLabelsByDefault: true,
    fieldsSchema: "http://www.azure.com/schema/formrecognizer/fields.json",
    labelsSchema: "http://www.azure.com/schema/formrecognizer/labels.json",
    enableMultiPageField: false,
    // pdfjsWorkerSrc(version: string) {
    //     return `https://fotts.azureedge.net/npm/pdfjs-dist/${version}/pdf.worker.js`;
    // },

    // pdfjsCMapUrl(version: string) {
    //     return `https://fotts.azureedge.net/npm/pdfjs-dist/${version}/cmaps/`;
    // },
    insightsKey: "",
    prebuiltServiceVersion: "2022-01-30-preview",
    pages: "pages"
};
